import { render, staticRenderFns } from "./TableSubDealerIndex.vue?vue&type=template&id=46a881db&scoped=true&"
import script from "./TableSubDealerIndex.vue?vue&type=script&lang=js&"
export * from "./TableSubDealerIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a881db",
  null
  
)

export default component.exports